((window, document) => {
    const requestEmail = document.getElementById('email-request-magic-link');

    const requestEmailAction = document.getElementById('email-request-action');
    const requestEmailContact = document.getElementById('email-request-contact');
    const requestEmailSuccess = document.getElementById('email-request-success');

    const urlParams = new URLSearchParams(window.location.search);
    const urlParamEmail = urlParams.get('email');

    if (!urlParamEmail && requestEmailAction && requestEmailContact) {
        requestEmailAction.classList.add('d-none');
        requestEmailContact.classList.remove('d-none');
    }

    if (requestEmail && urlParamEmail) {
        requestEmail.addEventListener('click', async () => {
            try {
                const tokenRequest = await fetch('/members/api/integrity-token');
                const token = await tokenRequest.text();

                await fetch('/members/api/send-magic-link/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        integrityToken: token,
                        email: decodeURIComponent(urlParamEmail),
                        emailType: 'signin',
                        autoRedirect: false,
                    }),
                });

                requestEmailAction.classList.add('d-none');
                requestEmailSuccess.classList.remove('d-none');
            } catch (e) {
                console.error(e);
            }
        })
    }
})(window, document);